import { useEffect, useRef } from 'react';
import { renderMarkdown } from '../../helpers';
import { StyledMessage } from './MessageStyles';

type TMessageProps = {
  message: string;
}

const Message = ({ message }: TMessageProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const links = containerRef.current?.querySelectorAll('a');
    links?.forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  }, []);

  return <StyledMessage
    ref={containerRef}
    dangerouslySetInnerHTML={{
      __html: renderMarkdown(message)
    }}
  />
};

export default Message;
